/*
 * mex-topics-toggle — the EXPLORE TOPICS "Show More / Show Less" control.
 *
 * Changes 7: this was an inline <script> duplicated verbatim in sections/blog.liquid and
 * sections/article-template.liquid. Two copies of one behaviour behind a window-level guard is a
 * drift hazard by construction — whichever section loads first wins, so an edit to one file could
 * silently do nothing. It is also the shape Shopify's own validator flags as a parser-blocking
 * script. One asset, loaded with defer from both sections, removes both problems.
 *
 * Contract with the markup (identical in both sections):
 *   [data-topics]                  the wrapper; gets .is-expanded
 *   [data-topics-toggle]           the button; ships hidden, revealed here
 *   [data-topics-toggle-label]     the words, swapped between data-more / data-less
 *   [data-topics-toggle-arrow]     the caret, flipped between ▼ and ▲
 *   .mex-topic--overflow           the tags past the tenth, display:none until expanded
 *
 * The label span is written rather than the button's textContent: assigning textContent would
 * destroy the caret node on the first click. The bare-textContent branch is the fallback for markup
 * without the spans.
 */
/* Changes 6 — Show More / Show Less for the topic tags.

   Wired document-wide and guarded, because this same block exists on the article template too
   and a blog page can render either. The button is revealed here rather than in the markup so
   it can never be a dead control when JS is unavailable. The count that decides whether it
   appears at all comes from Liquid, not from the DOM, so it is right on the first paint. */
(function () {
  if (window.__mexTopicsToggle) return;
  window.__mexTopicsToggle = true;
  function wire(root) {
    var btn = root.querySelector('[data-topics-toggle]');
    if (!btn || btn.dataset.mexWired) return;
    btn.dataset.mexWired = '1';
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      /* Changes 7 - write the LABEL span, never the button, or the caret node is destroyed on
         the first click. The bare-textContent fallback keeps a template without the spans
         working, because one guarded copy of this script serves both templates. */
      var lbl = btn.querySelector('[data-topics-toggle-label]');
      var arw = btn.querySelector('[data-topics-toggle-arrow]');
      var text = expanded ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      if (lbl) { lbl.textContent = text; } else { btn.textContent = text; }
      if (arw) { arw.textContent = expanded ? '\u25B2' : '\u25BC'; }
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }
  function init() {
    var nodes = document.querySelectorAll('[data-topics]');
    for (var i = 0; i < nodes.length; i += 1) wire(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
